export default __webpack_public_path__ + "static/media/icon-nature.0eef5ea8.svg";